import "core-js/modules/es.array.concat.js";
import { withTheme } from 'styled-components';
import React from 'react';
var RadioIcon = function RadioIcon(_ref) {
  var theme = _ref.theme,
    size = _ref.size,
    strokeWidth = _ref.strokeWidth;
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: size / 2 - strokeWidth || 3,
    fill: theme.checkboxActiveColor || theme.mainColor
  }));
};
export default withTheme(RadioIcon);